import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router';
import store from './store';
import axios from './plugins/axios';
import keycloak from './plugins/keycloak';
import rules from './plugins/rules';
import ToastPlugin from 'vue-toast-notification';
import './plugins/theme-toastification.css';
import ConfirmDeleteDialog from './views/dialogs/ConfirmDeleteDialog.vue';
import { registerScrollSpy } from 'vue3-scroll-spy';
import VueScrollTo from 'vue-scrollto';
import VueMask from '@devindex/vue-mask';
import ConfirmSaveDialog from './views/dialogs/ConfirmSaveDialog.vue';
import GeneralFormInputs from './components/GeneralFormInputs.vue';

const FRONT_PATH = process.env.VUE_APP_FRONT_PATH;
const API_PATH = process.env.VUE_APP_API_PATH;
const BACK_PATH = process.env.VUE_APP_BACK_PATH;
const PROF_PATH = process.env.VUE_APP_PROF_PATH;
const KC_URL = process.env.VUE_APP_KC_URL;
const KC_REALM = process.env.VUE_APP_KC_REALM;
const KC_CLIENT_ID = process.env.VUE_APP_KC_CLIENT_ID;


loadFonts();

async function initApp() {
  try {
    // 🔐 Inicializa o Keycloak uma única vez
    const authenticated = await keycloak.init({
      onLoad: 'check-sso', // ✅ não força login automático
      //silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      checkLoginIframe: false,
    });

    if (authenticated) {
      store.commit('setIsAuthenticated', true);
      store.commit('setUserData', keycloak.tokenParsed);
      store.commit('setToken', keycloak.token);
      store.commit('setResourceAccess', keycloak.resourceAccess);
    }

    // 🔧 Cria e configura o app
    const app = createApp(App);

    app.use(store)
      .use(router)
      .use(vuetify)
      .use(VueMask)
      .use(ToastPlugin, {
        position: 'top-right',
        duration: 4000,
        dismissible: true,
      })
      .use(rules)
      .use(VueScrollTo);

    registerScrollSpy(app);

    app
      .component('confirm-delete-dialog', ConfirmDeleteDialog)
      .component('confirm-save-dialog', ConfirmSaveDialog)
      .component('general-inputs', GeneralFormInputs);

    app.use(axios, { keycloak });
    app.config.globalProperties.$FRONTPATH = FRONT_PATH;
    app.config.globalProperties.$APIPATH = API_PATH;
    app.config.globalProperties.$BACKPATH = BACK_PATH;
    app.config.globalProperties.$PROFPATH = PROF_PATH;
    app.config.globalProperties.$KCURL = KC_URL;
    app.config.globalProperties.$KCREALM = KC_REALM;
    app.config.globalProperties.$KCCLIENTID = KC_CLIENT_ID;

    app.mount('#app');
  } catch (error) {
    console.error('❌ Erro ao inicializar Keycloak:', error);
  }
}

initApp();
